export const animeList = [
  {
    id: "a01",
    title: "星尘旅者的黄昏",
    jpTitle: "スターダスト・トラベラー",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20young%20traveler%20in%20a%20long%20coat%20standing%20on%20a%20cliff%20under%20a%20starry%20twilight%20sky%2C%20warm%20pink%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20detailed%20vertical%20poster%20composition&width=600&height=900&seq=anime-cover-01&orientation=portrait",
    genres: ["奇幻", "冒险"],
    day: "周一",
    status: "连载中",
    total: 12,
    latest: 9,
    score: 9.1,
    followers: "128.6万",
    year: "2026 秋",
    summary: "以银河边缘的巡星船为舞台，少女为寻找失落的航线图踏上旅程，每集解锁一颗星球的记忆。",
  },
  {
    id: "a02",
    title: "樱色交换日记",
    jpTitle: "さくらいろ交換日記",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20two%20high%20school%20students%20sharing%20a%20notebook%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20pastel%20palette%2C%20clean%20background%2C%20romantic%20vertical%20poster%20composition&width=600&height=900&seq=anime-cover-02&orientation=portrait",
    genres: ["恋爱", "校园"],
    day: "周一",
    status: "连载中",
    total: 12,
    latest: 8,
    score: 8.7,
    followers: "96.3万",
    year: "2026 秋",
    summary: "转学生与班长因一本写错名字的日记意外互通心事，青春在日常碎片里慢慢靠近。",
  },
  {
    id: "a03",
    title: "机械心脏的低语",
    jpTitle: "機械心臓のささやき",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20cyberpunk%20girl%20with%20a%20glowing%20mechanical%20heart%2C%20neon%20warm%20amber%20and%20pink%20accents%2C%20clean%20dark%20background%2C%20sci%20fi%20vertical%20poster%20composition&width=600&height=900&seq=anime-cover-03&orientation=portrait",
    genres: ["科幻", "悬疑"],
    day: "周二",
    status: "连载中",
    total: 13,
    latest: 10,
    score: 9.3,
    followers: "142.1万",
    year: "2026 秋",
    summary: "义体工程师发现每颗机械心脏都会留下遗言，一桩旧案与整座城市的记忆被重新翻开。",
  },
  {
    id: "a04",
    title: "厨房里的异世界",
    jpTitle: "台所の異世界",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20cozy%20fantasy%20kitchen%20with%20steaming%20dishes%20and%20tiny%20adventurers%2C%20warm%20cream%20and%20amber%20palette%2C%20clean%20simple%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-04&orientation=portrait",
    genres: ["日常", "治愈"],
    day: "周二",
    status: "连载中",
    total: 12,
    latest: 7,
    score: 8.5,
    followers: "74.8万",
    year: "2026 秋",
    summary: "退役勇者在小镇开了一间食堂，每一道家常菜都能化解客人来自异世界的烦恼。",
  },
  {
    id: "a05",
    title: "剑与月的誓约",
    jpTitle: "剣と月の誓い",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20swordswoman%20holding%20a%20glowing%20blade%20under%20a%20large%20moon%2C%20deep%20rose%20and%20gold%20palette%2C%20clean%20night%20background%2C%20epic%20vertical%20poster%20composition&width=600&height=900&seq=anime-cover-05&orientation=portrait",
    genres: ["战斗", "奇幻"],
    day: "周三",
    status: "连载中",
    total: 24,
    latest: 18,
    score: 9.0,
    followers: "156.4万",
    year: "2026 秋",
    summary: "背负誓约的剑士与失去记忆的月之巫女同行，两人要在月食前阻止一场古老的封印崩坏。",
  },
  {
    id: "a06",
    title: "午后三点的猫",
    jpTitle: "午後三時の猫",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20fluffy%20cat%20sleeping%20by%20a%20sunlit%20cafe%20window%2C%20soft%20cream%20and%20sage%20green%20palette%2C%20clean%20warm%20background%2C%20cozy%20vertical%20poster&width=600&height=900&seq=anime-cover-06&orientation=portrait",
    genres: ["治愈", "日常"],
    day: "周三",
    status: "连载中",
    total: 12,
    latest: 6,
    score: 8.6,
    followers: "68.2万",
    year: "2026 秋",
    summary: "咖啡店常客们的故事都从午后三点开始，而那只猫似乎总能出现在最需要陪伴的人身边。",
  },
  {
    id: "a07",
    title: "逆风跑者",
    jpTitle: "向かい風のランナー",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20teenage%20runner%20sprinting%20on%20a%20track%20at%20sunset%2C%20energetic%20rose%20and%20amber%20palette%2C%20clean%20dynamic%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-07&orientation=portrait",
    genres: ["运动", "校园"],
    day: "周四",
    status: "连载中",
    total: 25,
    latest: 20,
    score: 8.9,
    followers: "83.7万",
    year: "2026 秋",
    summary: "被诊断再无望夺冠的少年加入接力队，在每一棒交接中找回奔跑本身的意义。",
  },
  {
    id: "a08",
    title: "迷雾档案馆",
    jpTitle: "霧のアーカイブ",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20librarian%20holding%20a%20lantern%20inside%20a%20misty%20endless%20archive%2C%20muted%20rose%20and%20teal%20green%20palette%2C%20clean%20mysterious%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-08&orientation=portrait",
    genres: ["悬疑", "奇幻"],
    day: "周四",
    status: "连载中",
    total: 12,
    latest: 11,
    score: 9.2,
    followers: "119.5万",
    year: "2026 秋",
    summary: "管理员整理被封存的档案时，发现每份卷宗都会指向下一个失踪者，包括她自己。",
  },
  {
    id: "a09",
    title: "虚拟偶像练习生",
    jpTitle: "バーチャル練習生",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20virtual%20idol%20girl%20singing%20on%20a%20holographic%20stage%2C%20vibrant%20pink%20and%20gold%20palette%2C%20clean%20stage%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-09&orientation=portrait",
    genres: ["音乐", "日常"],
    day: "周五",
    status: "连载中",
    total: 12,
    latest: 9,
    score: 8.4,
    followers: "77.1万",
    year: "2026 秋",
    summary: "五位性格迥异的虚拟主播从零开始集训，舞台灯光背后是数据与人心的双重磨合。",
  },
  {
    id: "a10",
    title: "海底两万里的信",
    jpTitle: "海底二万里の手紙",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20girl%20in%20a%20submarine%20reading%20a%20letter%20surrounded%20by%20glowing%20fish%2C%20soft%20rose%20and%20aqua%20green%20palette%2C%20clean%20deep%20ocean%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-10&orientation=portrait",
    genres: ["冒险", "治愈"],
    day: "周五",
    status: "连载中",
    total: 12,
    latest: 5,
    score: 8.8,
    followers: "64.9万",
    year: "2026 秋",
    summary: "深海邮差每周穿过一整片海沟送信，收信人却从未露面，直到一次风暴改变了航线。",
  },
  {
    id: "a11",
    title: "龙脊山脉的远征",
    jpTitle: "竜骨山脈の遠征",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20an%20adventuring%20party%20crossing%20a%20dragon%20spine%20mountain%20range%2C%20heroic%20rose%20and%20amber%20palette%2C%20clean%20epic%20landscape%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-11&orientation=portrait",
    genres: ["冒险", "战斗"],
    day: "周六",
    status: "连载中",
    total: 24,
    latest: 22,
    score: 9.1,
    followers: "164.3万",
    year: "2026 秋",
    summary: "一支临时凑成的远征队穿越龙脊山脉，地图上标注的终点其实是一段被隐瞒的历史。",
  },
  {
    id: "a12",
    title: "时光邮局的来信",
    jpTitle: "時の郵便局",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20girl%20delivering%20letters%20inside%20a%20clockwork%20post%20office%2C%20warm%20rose%20and%20gold%20palette%2C%20clean%20fantasy%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-12&orientation=portrait",
    genres: ["恋爱", "奇幻"],
    day: "周六",
    status: "连载中",
    total: 12,
    latest: 10,
    score: 8.9,
    followers: "88.4万",
    year: "2026 秋",
    summary: "邮局只寄送写给过去的信，见习邮差在一次次投递中读懂了自己没能说出口的告别。",
  },
  {
    id: "a13",
    title: "特级料理研修生",
    jpTitle: "特級りょうり研修生",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20cheerful%20young%20chef%20flipping%20a%20pan%20in%20a%20busy%20kitchen%2C%20bright%20amber%20and%20rose%20palette%2C%20clean%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-13&orientation=portrait",
    genres: ["搞笑", "日常"],
    day: "周六",
    status: "连载中",
    total: 12,
    latest: 8,
    score: 8.2,
    followers: "58.6万",
    year: "2026 秋",
    summary: "天马行空的研修生把每一次考核都做成闹剧，却总能用一道菜让挑剔的评审闭嘴。",
  },
  {
    id: "a14",
    title: "银翼空战团",
    jpTitle: "銀翼の空戦団",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20female%20pilot%20in%20a%20futuristic%20aircraft%20above%20clouds%2C%20dynamic%20rose%20and%20amber%20palette%2C%20clean%20sky%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-14&orientation=portrait",
    genres: ["战斗", "科幻"],
    day: "周日",
    status: "连载中",
    total: 24,
    latest: 21,
    score: 9.0,
    followers: "137.2万",
    year: "2026 秋",
    summary: "浮空都市之间的竞赛演变成对抗，年轻飞行员必须在规则与信念之间做出选择。",
  },
  {
    id: "a15",
    title: "清晨的合唱部",
    jpTitle: "早朝の合唱部",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20school%20choir%20practicing%20at%20sunrise%20in%20a%20music%20room%2C%20soft%20rose%20and%20cream%20palette%2C%20clean%20bright%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-15&orientation=portrait",
    genres: ["音乐", "校园"],
    day: "周日",
    status: "连载中",
    total: 12,
    latest: 7,
    score: 8.5,
    followers: "61.7万",
    year: "2026 秋",
    summary: "面临解散的合唱部只剩四名成员，他们在清晨的教室里重新寻找愿意开口的声音。",
  },
  {
    id: "a16",
    title: "无声侦探社",
    jpTitle: "無音探偵社",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20calm%20detective%20in%20a%20quiet%20study%20with%20clues%20on%20a%20desk%2C%20muted%20rose%20and%20green%20palette%2C%20clean%20mystery%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-16&orientation=portrait",
    genres: ["悬疑", "推理"],
    day: "周日",
    status: "连载中",
    total: 12,
    latest: 9,
    score: 9.2,
    followers: "108.9万",
    year: "2026 秋",
    summary: "不说话的侦探只靠现场细节破案，而委托人隐瞒的那一句，往往才是真正的关键。",
  },
  {
    id: "a17",
    title: "花瓣与铁锤",
    jpTitle: "花びらと金鎚",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20young%20blacksmith%20surrounded%20by%20falling%20petals%20in%20a%20workshop%2C%20warm%20rose%20and%20amber%20palette%2C%20clean%20cozy%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-17&orientation=portrait",
    genres: ["奇幻", "日常"],
    day: "周一",
    status: "已完结",
    total: 12,
    latest: 12,
    score: 8.7,
    followers: "52.4万",
    year: "2026 夏",
    summary: "小镇铁匠接下为花祭打造徽章的工作，一件件作品串起了整条街的人情往来。",
  },
  {
    id: "a18",
    title: "云端便利店",
    jpTitle: "雲のコンビニ",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20small%20convenience%20store%20floating%20on%20clouds%20at%20dusk%2C%20soft%20rose%20and%20cream%20palette%2C%20clean%20dreamy%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-18&orientation=portrait",
    genres: ["日常", "治愈"],
    day: "周三",
    status: "已完结",
    total: 13,
    latest: 13,
    score: 8.6,
    followers: "49.8万",
    year: "2026 夏",
    summary: "开在云层之上的便利店只在黄昏营业，客人带来的故事比货架上的商品更值得收藏。",
  },
  {
    id: "a19",
    title: "星图占卜屋",
    jpTitle: "星図の占い屋",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20fortune%20teller%20reading%20a%20glowing%20star%20chart%20in%20a%20cozy%20shop%2C%20deep%20rose%20and%20gold%20palette%2C%20clean%20magical%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-19&orientation=portrait",
    genres: ["奇幻", "恋爱"],
    day: "周五",
    status: "连载中",
    total: 12,
    latest: 11,
    score: 8.8,
    followers: "71.3万",
    year: "2026 秋",
    summary: "占卜屋的预言从不出错，除了占卜师自己那段被星图抹去的过去。",
  },
  {
    id: "a20",
    title: "深海回声",
    jpTitle: "深海のこだま",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20diver%20listening%20to%20mysterious%20echoes%20in%20a%20dark%20trench%2C%20muted%20rose%20and%20teal%20palette%2C%20clean%20mysterious%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-20&orientation=portrait",
    genres: ["悬疑", "科幻"],
    day: "周四",
    status: "连载中",
    total: 12,
    latest: 8,
    score: 9.1,
    followers: "94.6万",
    year: "2026 秋",
    summary: "声呐员在海沟深处捕捉到规律的回声，破译后竟是一段来自未来的求救讯号。",
  },
  {
    id: "a21",
    title: "武道少年行",
    jpTitle: "武道少年の旅",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20martial%20arts%20boy%20training%20in%20an%20old%20dojo%20at%20dawn%2C%20earthy%20rose%20and%20amber%20palette%2C%20clean%20dynamic%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-21&orientation=portrait",
    genres: ["运动", "战斗"],
    day: "周六",
    status: "连载中",
    total: 24,
    latest: 19,
    score: 8.9,
    followers: "99.7万",
    year: "2026 秋",
    summary: "少年带着师父的旧木刀走出山村，一路上遇见的对手都藏着同一门派的不同答案。",
  },
  {
    id: "a22",
    title: "甜品魔法工房",
    jpTitle: "お菓子魔法工房",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20magical%20bakery%20with%20colorful%20cakes%20and%20sparkles%2C%20pastel%20rose%20and%20cream%20palette%2C%20clean%20cute%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-22&orientation=portrait",
    genres: ["治愈", "搞笑"],
    day: "周二",
    status: "连载中",
    total: 12,
    latest: 6,
    score: 8.3,
    followers: "55.2万",
    year: "2026 秋",
    summary: "会施法的甜品师坚持不用魔法调味，靠笨办法和一点点心意做出让人笑的点心。",
  },
  {
    id: "a23",
    title: "废墟上的花园",
    jpTitle: "廃墟の庭",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20girl%20planting%20flowers%20in%20a%20sunny%20ruined%20city%2C%20soft%20rose%20and%20green%20palette%2C%20clean%20hopeful%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-23&orientation=portrait",
    genres: ["剧情", "治愈"],
    day: "周日",
    status: "已完结",
    total: 12,
    latest: 12,
    score: 9.2,
    followers: "86.5万",
    year: "2026 夏",
    summary: "战后城市里唯一的孩子在废墟种花，渐渐让成年人重新相信明天值得等待。",
  },
  {
    id: "a24",
    title: "极夜列车",
    jpTitle: "極夜列車",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20mysterious%20night%20train%20crossing%20a%20snowy%20polar%20landscape%2C%20moody%20rose%20and%20amber%20palette%2C%20clean%20cinematic%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-24&orientation=portrait",
    genres: ["悬疑", "奇幻"],
    day: "周五",
    status: "连载中",
    total: 13,
    latest: 12,
    score: 9.0,
    followers: "102.8万",
    year: "2026 秋",
    summary: "一列只在极夜行驶的列车载着各怀心事的乘客，每停靠一站就有人必须下车面对真相。",
  },
];

export const dayTabs = ["全部", "周一", "周二", "周三", "周四", "周五", "周六", "周日"];

export const genreOptions = [
  "全部",
  "奇幻",
  "战斗",
  "恋爱",
  "日常",
  "校园",
  "科幻",
  "悬疑",
  "治愈",
  "搞笑",
  "运动",
  "冒险",
  "音乐",
  "推理",
  "剧情",
];